import { Button, Divider, Flex, Title } from '@tremor/react'
import { useEffect, useState } from 'react'

interface IConfirm {
    show: boolean
    title: string
    loading: boolean
    error: string
    onCanceled: () => void
    onConfirmed: () => void
}

export default function Confirm({
    title,
    show,
    loading,
    error,
    onCanceled,
    onConfirmed,
}: IConfirm) {
    const [isVisible, setIsVisible] = useState(show)

    useEffect(() => {
        if (show) {
            setIsVisible(true)
            return () => 0
        }
        const timeout = setTimeout(() => setIsVisible(false), 150)
        return () => clearTimeout(timeout)
    }, [show])

    return (
        <Flex
            flexDirection="col"
            justifyContent="center"
            alignItems="center"
            className={`fixed top-0 left-0 w-screen h-screen bg-gray-900/50 z-50 transition-opacity duration-75 ease-linear ${
                show ? 'opacity-100 visible' : 'opacity-0'
            } ${isVisible ? 'visible' : 'invisible'}`}
            onClick={onCanceled}
        >
            <Flex
                flexDirection="row"
                alignItems="start"
                justifyContent="start"
                className="w-fit h-fit bg-white rounded-md border-l border-gray-300"
                onClick={(e) => {
                    e.stopPropagation()
                }}
            >
                <Flex
                    flexDirection="col"
                    justifyContent="start"
                    alignItems="center"
                >
                    <Title className="p-4">{title}</Title>
                    <Flex
                        flexDirection="row"
                        justifyContent="between"
                        alignItems="start"
                        className="px-8 w-fit space-x-10 py-6"
                    >
                        <Button
                            disabled={loading}
                            loading={loading}
                            color="rose"
                            onClick={onConfirmed}
                        >
                            Yes
                        </Button>
                        <Button
                            variant="secondary"
                            color="gray"
                            onClick={onCanceled}
                        >
                            No
                        </Button>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    )
}
